<button
  class="button"
  [type]="this.config().type === 'submit' ? 'submit' : 'button'"
  [disabled]="!this.config().form.valid"
  [ngClass]="{
    valid: this.config().form.valid,
    invalid: !this.config().form.valid
  }"
>
  {{ this.config().text }}
</button>
